import type { InternalDiscoveryRunDto } from '@terra/shared-contracts-internal-network';

export type InternalNetworkDiscoveryRunStatus =
  InternalDiscoveryRunDto['status'];

export const ACTIVE_INTERNAL_NETWORK_DISCOVERY_RUN_STATUSES = [
  'ENROLLING',
  'COLLECTING',
  'IMPORTING',
  'NORMALIZING',
  'ANALYZING',
] as const satisfies readonly InternalNetworkDiscoveryRunStatus[];

export const isActiveInternalNetworkDiscoveryRunStatus = (
  status: InternalNetworkDiscoveryRunStatus,
): boolean =>
  (
    ACTIVE_INTERNAL_NETWORK_DISCOVERY_RUN_STATUSES as readonly string[]
  ).includes(status);

export const hasActiveInternalNetworkDiscoveryRun = (
  runs: ReadonlyArray<{ status: InternalNetworkDiscoveryRunStatus }>,
): boolean =>
  runs.some((run) => isActiveInternalNetworkDiscoveryRunStatus(run.status));
